import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import {
  addSkillAction,
  initialSkillState,
} from "../../../../store/reducers/assignWorkerSlice";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import FormField from "../../../../components/common/FormField";
import { SKILL_FIELDS } from "./allFormFields";
import { useDispatch } from "react-redux";
import Validation from "../../../../utils/Validation";
import ResetFormAlert from "./ResetFormAlert";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
interface ManagePopupProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedData: any; // Adjust type as per your requirement
  isSmallScreen?: boolean; //
  action?: string;
}

const ManageSkill = (props: ManagePopupProps) => {
  const classes = useStyles();
  const { selectedData, onHide, open, title, action, isSmallScreen } = props;
  const [formData, setFormData] = useState<any>(initialSkillState);
  const dispatch = useDispatch();
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    title: formData?.title,
  });

  useEffect(() => {
    if (selectedData) {
      setFormData(selectedData);
    }
  }, [selectedData]);

  const hideHandler = () => {
    onHide();
    resetAllValidator();
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        if (action === "edit" && selectedData?.id) {
          const {
            id,
            updated_by,
            updated_at,
            created_at,
            created_by,
            ...rest
          } = formData;
          dispatch(addSkillAction({ ...rest, id: selectedData?.id }));
        } else {
          dispatch(addSkillAction(formData));
        }
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleInputChange = (field: string, value: any) => {
    setFormData((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));

    resetValidator(field);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

     const handleClear = () => {
      if (selectedData?.id && action === "edit") {
        setFormData({...selectedData} );
       
      }else {
        setFormData(initialSkillState);
      }
      
      dispatch(setNotificationAction({ message: [], severity: "error" }));
      resetAllValidator();
      setIsClickReset(false);
    };

    useEffect(() => {
      if (isClickReset) {
        handleClear();
        setAlertModelShow(false);
      }
    }, [isClickReset]);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"sm"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                direction="row"
                spacing={0.5}
                rowGap={0}
                rowSpacing={0}
                sx={{
                  background: "#E5F4F1",
                  padding: "10px !important",
                  marginTop: "10px !important",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                  overflow: "hidden",
                }}
              >
                {SKILL_FIELDS.map((field, i) => {
                  return (
                    <FormField
                      // onPaste={(e) =>
                      //   field?.id === "title" ? "" : e.preventDefault()
                      // }
                      onKeyDown={(event: any) => {
                        console.log(
                          "event log-",
                          event,
                          event.target.value + event.key
                        );
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...field,
                        ...{
                          variant: "outlined", // Adding this variant prop
                          inSingleGridForm: true,
                          isNonMarginTop: true,
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx: {
                              height:
                                field?.id === "notes" &&
                                formData[field?.id]?.length > 36
                                  ? "auto"
                                  : "36px",
                              padding: field?.id === "notes" ? "4px" : "",
                            },
                            // ...(selectUser && { disabled: field?.editReadOnly }),
                            autocomplete: "user-new-field",
                          },

                          value: formData ? formData[field.id] : "",
                          onBlur: onBlurAction,
                          // selectedValues: materialDetail[field?.id],
                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          error: error && error[field?.id],
                        },
                      }}
                    />
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};
export default ManageSkill;
